import { emptyV2Api as api } from "../../emptyV2Api";
import { PlanUploadJobItem } from "../uploads/products/planUploadJobItem";
import { UsimMappingItem, UsimMappingResponse } from "./UsimMappingItem";

const SLUG = "/usim/mappings"

const injectedApi = api
  .enhanceEndpoints({ addTagTypes: ["mapping"] })
  .injectEndpoints({
    endpoints: (build) => ({
      getUsimMappings: build.query<UsimMappingItem [], string>({
        query: (vendorId) => SLUG + "/manage?vendorId=" + vendorId,
        providesTags: ["mapping"]
      }),
      getUsimMapping: build.query<UsimMappingItem, string>({
        query: (internalSku) => SLUG + "/" + internalSku,
        providesTags: ["mapping"]
      }),
      getUsimMappingUploadJobs: build.query<PlanUploadJobItem[], void>({
        query: () => SLUG + "/upload",
        providesTags: ["mapping"]
      }),
     
    })
});

export const {
  useGetUsimMappingsQuery,
  useGetUsimMappingUploadJobsQuery,
} = injectedApi;